import {
    AdvanceOrderTypesI,
    OrderModeInterface,
    OrderTypeInterface,
    ReverseInstrumentInterface,
    InstrumentInterface,
    IOrderValidity,
    OrderStatusInterface,
    IReverseOrderValidity,
    ConfirmDialogActions,
    ProductConversionModeInterface,
    IReverseOptionKeyword,
} from './app.interface';
import { ProductType as ProtoProductType } from './providers/utProto/enums_pb';
import { OrderMode as ProtoOrderMode } from './providers/utProto/enums_pb';
import { LogoutReason as ProtoLogoutReason } from './providers/utProto/enums_pb';
import { OrderType as ProtoOrderType } from './providers/utProto/enums_pb';
import { OrderCateGory as ProtoOrderCategory } from './providers/utProto/enums_pb';
import { BOCOPriceType as ProtoBOCOPriceType } from './providers/utProto/enums_pb';
import { PayoutType as ProtoPayoutType } from './providers/utProto/enums_pb';

export enum LoginStatus {
    active = 'Active',
    failed = 'Failed',
    closed = 'Closed'
}

export enum OrderCategory {
    single = 'single',
    spread = 'spread',
    amo = 'amo',
    multileg = 'multi leg',
    auction = 'auction'

}

export enum PositionView {
    day = 'DAY',
    all = 'ALL'
}
export enum LogoutProtoMessage {
    ChangePassword = ProtoLogoutReason.LOGOUTREASON_CHANGE_PASSWORD,
    TotpEnable = ProtoLogoutReason.LOGOUTREASON_TOTP_ENABLE,
    TotpDisable = ProtoLogoutReason.LOGOUTREASON_TOTP_DISABLE
}

export enum PositionFilter {
    open = 'Open',
    all = '-1',
    close = 'Closed',
    long = 'Long',
    short = 'Short',
    day = 'Day'
}


export enum PlatformType {
    WEB = 'web',
    MOBILE = 'mobile',
    All = 'all',
    IOS = 'ios',
    ANDORID = 'android',
    DMA = 'dma'
}

export let ConfirmDialogAction: ConfirmDialogActions;
(function (reverseInst) {
    reverseInst[reverseInst['modify_order'] = 'Modify Order'] = 'modify_order';
    reverseInst[reverseInst['cancel_order'] = 'Cancel Order'] = 'cancel_order';
    reverseInst[reverseInst['squareoff_order'] = 'Open Order Form'] = 'squareoff_order';
    reverseInst[reverseInst['exit_order'] = 'Exit Order'] = 'exit_order';
    reverseInst[reverseInst['logout'] = 'Logout'] = 'logout';
    reverseInst[reverseInst['stay_signed_in'] = 'No, stay signed in!'] = 'stay_signed_in';
    reverseInst[reverseInst['cancel'] = 'CANCEL'] = 'cancel';
    reverseInst[reverseInst['proceed'] = 'PROCEED'] = 'proceed';
})(ConfirmDialogAction || (ConfirmDialogAction = <ConfirmDialogActions>{}));

export enum AccessType {
    mobile = 'Mobile',
    desktop = 'Desktop',
    web = 'Web',
    dma = 'DMA',
    uAlgoMobile = 'uAlgoMobile'
}

export const SvgIconPathMap = {
    windows: '../assets/icons/windows.svg',
    linux: '../assets/icons/linux.svg',
    browser: '../assets/icons/chrome.svg',
    apple: '../assets/icons/apple.svg',
    android: '../assets/icons/android.svg',
    utradeAlgos: '../assets/icons/uTradeAlgos.svg',
    chromeIcon: '../assets/icons/chrome-icon.svg',
    firefoxIcon: '../assets/icons/firefox.svg',
    safariIcon: '../assets/icons/safari-icon.svg',
    shareIndia: '../assets/icons/shareindia-default.svg',
    brave: '../assets/icons/brave.svg',
    opera: '../assets/icons/opera.svg',
    edge: '../assets/icons/edge.svg',
    pesb: '../assets/icons/pesb.svg',
    pin: '../assets/icons/pinIcon.svg',
    chart: '../assets/icons/chart.svg',
    link: '../assets/icons/link.svg',
 whatsNew: '../assets/icons/whatsNew.svg',
    whatsNewWhite: '../assets/icons/whatsNewWhite.svg',
    candlestick: '../assets/icons/candlestick.svg',
    aiSymbol: '../assets/icons/ai_symbol.svg',
    aiSpark: '../assets/images/ai_spark.svg',

    // analytics icons
    ai_insight: '../assets/cmots/ai_insight.svg',
    ai_key_factor: '../assets/cmots/ai_key_factor.svg',
    fm_performance: '../assets/cmots/fm_performance.svg',
    fm_price_volatility: '../assets/cmots/fm_price_volatility.svg',
    fm_quality: '../assets/cmots/fm_quality.svg',
    fm_sentiment: '../assets/cmots/fm_sentiment.svg',
    fm_valuation: '../assets/cmots/fm_valuation.svg',
    swot_strength: '../assets/cmots/swot_strength.svg',
    swot_weakness: '../assets/cmots/swot_weakness.svg',
    swot_opportunity: '../assets/cmots/swot_opportunity.svg',
    swot_threat: '../assets/cmots/swot_threat.svg',
    // dark theme icons
    fm_quality_white: '../assets/cmots/fm_quality_white.svg',
    fm_valuation_white: '../assets/cmots/fm_valuation_white.svg',
    fm_sentiment_white: '../assets/cmots/fm_sentiment_white.svg',
    fm_performance_white: '../assets/cmots/fm_performance_white.svg',
    fm_price_volatility_white: '../assets/cmots/fm_price_volatility_white.svg',
    swot_threat_white: '../assets/cmots/swot_threat_white.svg',
    swot_strength_white: '../assets/cmots/swot_strength_white.svg',
    swot_weakness_white: '../assets/cmots/swot_weakness_white.svg',
    swot_opportunity_white: '../assets/cmots/swot_opportunity_white.svg',
};


export enum DeviceTypes {
    windows = 'Windows',
    linux = 'Linux',
    chrome = 'Chrome',
    safari = 'Safari',
    apple = 'Apple',
    android = 'Android',
    firefox = 'Firefox',
    opera = 'Opera',
    brave = 'Brave',
    edge = 'Edge'

}

export enum platformtype {
    ios = 'ios',
    android = 'android',
    cordova = 'cordova'
}

export const DeviceNameIconMap = {
    'windows': { 'name': 'Windows', 'icon': 'windows' },
    'linux': { 'name': 'Linux', 'icon': 'linux' },
    'web': { 'name': 'Browser', 'icon': 'browser' },
    'mobile-apple': { 'name': 'Mobile', 'icon': 'apple' },
    'mobile-android': { 'name': 'Mobile', 'icon': 'android' },
    'utradeAlgos': { 'name': 'uTrade Algos', 'icon': 'utradeAlgos' },
    'uAlgosMobile': { 'name': 'uTrade Algos Mobile', 'icon': 'utradeAlgos' },
    'chrome': { 'name': 'Browser', 'icon': 'chromeIcon' },
    'firefox': { 'name': 'Firefox', 'icon': 'firefoxIcon' },
    'safari': { 'name': 'Safari', 'icon': 'safariIcon' },
    'shareIndia': { 'name': 'ShareIndia', 'icon': 'shareIndia' },
    'brave': { 'name': 'Brave', 'icon': 'brave' },
    'opera': { 'name': 'Opera', 'icon': 'opera' },
    'edge': { 'name': 'Edge', 'icon': 'edge' },
    'pesb': { 'name': 'PESB', 'icon': 'pesb' },
};


export enum OrderStatus {
    confirmed = 'confirmed',
    partially_filled = 'partially_filled',
    replaced = 'replaced',
    rms_reject = 'rms_reject',
    new_rejected = 'new_rejected',
    replace_rejected = 'replace_rejected',
    cancel_rejected = 'cancel_rejected',
    cancelled = 'cancelled',
    filled = 'filled',
    frozen = 'frozen',
    pending_new = 'pending_new',
    pending_replace = 'pending_replace',
    pending_cancel = 'pending_cancel',
    amo_pending = 'amo_pending',
    amo_replaced = 'amo_replaced',
    amo_cancelled = 'amo_cancelled',
    amo_rejected = 'amo_rejected',
    amo_replace_rejected = 'amo_replace_rejected',
    amo_cancel_rejected = 'amo_cancel_rejected',
    schedule_new = 'schedule_new',
    schedule_replaced = 'schedule_replaced',
    schedule_pending = 'schedule_pending',
    schedule_cancelled = 'schedule_cancelled',
    schedule_rejected = 'schedule_rejected',
    open = 'open',
    completed = 'completed',
    active = 'active'
}

export const HideTransactionHistoryStatus = [
    OrderStatus.rms_reject,
    OrderStatus.frozen,
    OrderStatus.pending_new
];


export const ConditionalTransactionHistoryStatus = [
    OrderStatus.new_rejected
];

// status of orders that are executed. 
// This is used to filter out executed orders from the orders data 
// and calculate over all buy and sell volues for open orders
export const ExecutedOrderStatus = [
    OrderStatus.filled,
    OrderStatus.cancelled,
    OrderStatus.amo_rejected,
    OrderStatus.amo_cancelled,
    OrderStatus.rms_reject,
    OrderStatus.new_rejected,
    OrderStatus.replace_rejected,
    OrderStatus.cancel_rejected,
    OrderStatus.frozen,
    OrderStatus.amo_replace_rejected,
    OrderStatus.amo_cancel_rejected,
    OrderStatus.schedule_rejected

]

export enum BOCOOrderStatus {
    New = 'new',
    Accepted = 'accepted',
    Rejected = 'rejected',
    Split = 'split',
    NewSpawned = 'new_spawned',
    ModificationPending = 'modification_pending',
    ModificationAccepted = 'modification_accepted',
    ModificationRejected = 'modification_rejected',
    Cancelled = 'cancelled',
    CancelRejected = 'cancel_rejected',
    Completed = 'completed',
    ExitAllowed = 'exit_allowed',
    PartialFill = 'partial_fill',
    Filled = 'filled',
    Exit = 'exit',
    Max = 'max'
}

export const MarketWatchSymbolType = {
    Symbol: 'symbol',
    Index: 'index'
};

export enum Series {
    EQ = 'EQ',
    A = 'A'
}

export let Instrument: InstrumentInterface;
(function (reverseInst) {
    reverseInst[reverseInst['common_stock'] = 'Equity'] = 'common_stock';
    reverseInst[reverseInst['future'] = 'Future'] = 'future';
    reverseInst[reverseInst['option'] = 'Option'] = 'option';
    reverseInst[reverseInst['index'] = 'Index'] = 'index';
})(Instrument || (Instrument = <InstrumentInterface>{}));

export let OrderValidity: IOrderValidity;
(function (reverseOrder) {
    reverseOrder[reverseOrder['day'] = 'DAY'] = 'day';
    reverseOrder[reverseOrder['gtc'] = 'GTC'] = 'gtc';
    reverseOrder[reverseOrder['ioc'] = 'IOC'] = 'ioc';
    reverseOrder[reverseOrder['ato'] = 'ATO'] = 'ato';
    reverseOrder[reverseOrder['gtd'] = 'GTD'] = 'gtd';
    reverseOrder[reverseOrder['atc'] = 'ATC'] = 'atc';
    reverseOrder[reverseOrder['fok'] = 'FOK'] = 'fok';
})(OrderValidity || (OrderValidity = <IOrderValidity>{}));

// export let OrderStatusAcronym: OrderStatusInterface;
// (function (reverseInst) {
//     reverseInst[reverseInst['confirmed'] = 'Confirmed'] = 'confirmed';
//     reverseInst[reverseInst['partially_filled'] = 'Partially Filled'] = 'partially_filled';
//     reverseInst[reverseInst['replaced'] = 'Replaced'] = 'replaced';
//     reverseInst[reverseInst['rejected'] = 'Rejected'] = 'rejected';
//     reverseInst[reverseInst['new_rejected'] = 'New Rejected'] = 'new_rejected';
//     reverseInst[reverseInst['rms_reject'] = 'RMS Rejected'] = 'rms_reject';
//     reverseInst[reverseInst['RiskStatus_EXCHANGE_DISCONNECTED'] = 'EXCHANGE DISCONNECTED'] = 'RiskStatus_EXCHANGE_DISCONNECTED';
//     reverseInst[reverseInst['replace_rejected'] = 'Replace Rejected'] = 'replace_rejected';
//     reverseInst[reverseInst['cancel_rejected'] = 'Cancel Rejected'] = 'cancel_rejected';
//     reverseInst[reverseInst['cancelled'] = 'Cancelled'] = 'cancelled';
//     reverseInst[reverseInst['filled'] = 'Filled'] = 'filled';
//     reverseInst[reverseInst['frozen'] = 'Frozen'] = 'frozen';
//     reverseInst[reverseInst['pending_new'] = 'Pending New'] = 'pending_new';
//     reverseInst[reverseInst['pending_replace'] = 'Pending Replace'] = 'pending_replace';
//     reverseInst[reverseInst['pending_cancel'] = 'Pending Cancel'] = 'pending_cancel';
// })(OrderStatusAcronym || (OrderStatusAcronym = <OrderStatusInterface>{}));


export let ReverseOrderValidityMapping: IReverseOrderValidity;
(function (reverseOrder) {
    reverseOrder[reverseOrder['day'] = 'DAY'] = 'day';
    reverseOrder[reverseOrder['gtc'] = 'GTC'] = 'gtc';
    reverseOrder[reverseOrder['ioc'] = 'IOC'] = 'ioc';
    reverseOrder[reverseOrder['ato'] = 'ATO'] = 'ato';
    reverseOrder[reverseOrder['gtd'] = 'GTD'] = 'gtd';
    reverseOrder[reverseOrder['atc'] = 'ATC'] = 'atc';
    reverseOrder[reverseOrder['fok'] = 'FOK'] = 'fok';
})(ReverseOrderValidityMapping || (ReverseOrderValidityMapping = <IReverseOrderValidity>{}));


export enum ProductType {
    delivery = 'Delivery',
    intraDay = 'Intraday',
    carryForward = 'CarryForward',
    nonDPSell = 'NonDPSell',
    mtf = 'MTF'
}

export enum OrderValidityType {
    DAY = 'DAY',
    IOC = 'IOC'
}

export const taxOrderMode = {
    'Buy': ProtoOrderMode.ORDERMODE_BUY,
    'Sell': ProtoOrderMode.ORDERMODE_SELL
}

export const marginOrderType = {
    'limit': ProtoOrderType.ORDERTYPE_LIMIT,
    'market': ProtoOrderType.ORDERTYPE_MARKET,
    'stop_loss_limit': ProtoOrderType.ORDERTYPE_STOP_LIMIT,
    'stop_loss_market': ProtoOrderType.ORDERTYPE_STOP,
}

export const marginOrderCategory = {
    'single': ProtoOrderCategory.ORDERCATEGORY_SINGLE,
    'spread': ProtoOrderCategory.ORDERCATEGORY_SPREAD,
    'amo': ProtoOrderCategory.ORDERCATEGORY_AFTER_MARKET_ORDER,
}

export const ProtoBOCOPriceTypeMap = {
    'absolute': ProtoBOCOPriceType.BOCOPRICETYPE_ABSOLUTE,
    'tick': ProtoBOCOPriceType.BOCOPRICETYPE_TICKS,
    'default': ProtoBOCOPriceType.BOCOPRICETYPE_MAX
}

export enum OptionTypeEnum {
    CALL = 'call',
    PUT = 'put'
}

export enum AmbiguousKeywords {
    'PUT' = 'PE',
    'CALL' = 'CE',
}

export enum PayoutTypeEnum {
    regular = ProtoPayoutType.PAYOUTTYPE_REGULAR,
    instant = ProtoPayoutType.PAYOUTTYPE_INSTANT
}

export enum subTabsEnum {
    BOOK_SUB_TABS = 'books',
    HOLDINGS_SUB_TABS = 'holdings',
    MTF_SUB_TABS = 'mtf',
}

export const BOOK_TABS = {
    ORDER_BOOK: 0,
    TRADE_BOOK: 1,
    SIP_BOOK: 2,
    GTT_BOOK: 3,
    SMART_BOOK: 4,
    SUPER_BOOK: 5
}

export enum HoldingsTabType {
    ALL = 0,
    EQUITY = 1,
    MUTUAL_FUNDS = 2,
    MTF = 3
}

export enum HoldingsTabLabel {
    ALL = 'All',
    EQUITY = 'Equity',
    MUTUAL_FUNDS = 'Mutual Funds',
    MTF = 'MTF'
} 

export const ORDER_STATUS_TAB_MAPPING = {
    [OrderStatus.filled]: BOOK_TABS.TRADE_BOOK,
    [OrderStatus.partially_filled]: BOOK_TABS.TRADE_BOOK,
    // [OrderStatus.schedule_new]: BOOK_TABS.GTT_BOOK,
};

export let ReversedOptionKeywords: IReverseOptionKeyword;
(function (reverseOrder) {
    reverseOrder[reverseOrder['PE'] = 'PUT'] = 'PE';
    reverseOrder[reverseOrder['CE'] = 'CALL'] = 'CE';
})(ReversedOptionKeywords || (ReversedOptionKeywords = <IReverseOptionKeyword>{}));


export enum PendingStatus {
    pending_new = 'pending_new',
    pending_replace = 'pending_replace',
    pending_cancel = 'pending_cancel'
}

export enum MostActiveSortType {
    volume = 'volume',
    value = 'value'
}


export enum TwoFAMessages {
    Success = 'Success',
    Failure = 'Failure',
    Limit = 'Limit',
    System = 'System'

}

export enum MarketMoversOrderTypes {
    instrument = 'Instrument',
    index = 'Index'
}

export enum ResetPasswordStatus {
    normal = 'A',
    firstTimeLogin = 'N'
}

// Channels structs

export enum SocketConnections {
    order = 'orders/stream/',
    marketData = 'market_data/stream/',
    aiScreener = 'agents/stream/'
}

export enum StreamTypes {
    orders = 'orders',
    trades = 'trades',
    margin = 'margin',
    commands = 'commands',
    heartbeat = 'heartbeat',
    ipo = 'ipo',
    edis = 'edis',
    module_connection_status = 'module_connection_status',
    pledge = 'pledge',
    gtt_order_notification = 'gtt_order_notification',
    live_messages = 'live_messages',
    smart_orders_update = 'smart_orders_update',
    payout_param_update = 'payout_param_update'
}

export enum MarketStreams {
    quotes = 'quotes',
    depth = 'depth',
    openInterest = 'openInterest',
    notices = 'notices',
    indices = 'indices',
    dpr = 'dpr'
}

export enum AIScreenerStreams {
    aiAssistant = 'aiAssistant',
}

export enum SocketCommands {
    subscribe = 'subscribe',
    subscribeMtf = 'subscribe_to_mtf',
    subscribeDepth = 'subscribe-depth',
    subscribeQuote = 'subscribe-quote',
    unsubscribeDepth = 'unsubscribe-depth',
    unsubscribeQuote = 'unsubscribe-quote',
    authenticate = 'authenticate',
    ping = 'ping',
    send = 'send',
    logs = 'logs',
    connection_status = 'connection_status',
    createScreener = 'createScreener'
}

export enum SocketErrors {
    authError = 'Authentication Error',
    invalidTokenError = 'Authentication Error ! Invalid Token'
}

export enum SockRoutes {
    orderbook = 'OrderBookData',
    tradebook = 'TradeBookData',
    gttbook = 'GTTBookData',
    postions = 'PositionsData',
    margin = 'MarginsData',
    holding = 'HoldingsData',
    mtf = 'MtfData',
    mtfMargin = 'MtfMarginData',
    rejection = 'RejectionsData',
    marketwatch = 'MarketWatch',
    orderdepth = 'OrderDepth',
    broadcastMessages = 'BroadcastMessages',
    alertsData = 'AlertsData',
    openInterest = 'OpenInterest',
    dpr = 'dpr',
    bocoData = 'bocoData',
    indices = 'indices',
    notices = 'notice',
    marketSession = 'market_session',
    commands = 'commands',
    fo_ban = 'fo_ban',
    productConversionSummary = 'productConversionSummary',
    mapping = 'mapping',
    kyc_status = 'kyc_status',
    dms_connection_status = 'dms_connection_status',
    funds_status = 'funds_status',
    ipo = 'ipo',
    edis = 'edis',
    hft_connection_status = 'hft_connection_status',
    mutualFund = 'mutualFund',
    pledge = 'pledge',
    screener = 'aiScreener',
    liveMessages = 'liveMessages',
    smart_orders_update = 'smart_orders_update',
    payout_params = 'payout_params'
}

export enum AdminCommands {
    logout = 'logout',
    delete = 'delete',
    pass_modify = 'pass_modify',
}

/* Support to be added Later */
export enum ChartIntervals {
    '1m' = '1m',
    // '3m' = '3m',
    '5m' = '5m',
    '10m' = '10m',
    '15m' = '15m',
    '30m' = '30m',
    '1h' = '1h',
    // '4h' = '4h',
    '1d' = '1d',
    // '5d' = '5d',
    '1W' = '1w',
    'W' = '1w',
    '1M' = '1M',
    'M' = '1M'
}

/* Support to be added Later */
export enum MarketIntervals {
    '1m' = '1 MIN',
    '5m' = '5 MINS',
    '10m' = '10 MINS',
    '15m' = '15 MINS',
    '30m' = '30 MINS',
    '1h' = '60 MINS'
}
export enum ChartDisplayIntervals {
    '1m' = '1 min',
    '5m' = '5 min',
    '10m' = '10 min',
    '30m' = '30 min',
    '1h' = '1 hour',
    '1d' = '1 day',
    '5d' = '1 week',
    '1M' = '1 month',
}

export enum SortingTypes {
    None = 0,
    Ascending = 1,
    Descending = 2,
}

export enum ExtendedCandled {
    '1m' = '1m',
    // '3m' = '3m',
    '5m' = '5m',
    '10m' = '10m',
    '15m' = '15m',
    '30m' = '30m',
    '1h' = '1h',
    // '4h' = '4h',
    '1d' = '1d',
    /* '5d' = '5d',
    '1w' = '1w',
    '1M' = '1M' */
}

export enum ChartTypes {
    candle = 'Candle Stick',
    line = 'Line',
    OHLC = 'OHLC',
    area = 'Area Chart'
}

export enum ChartUpdateType {
    new = 'new',
    update = 'update'
}

export enum DialogType {
    modify = 'Modify',
    squareOff = 'SquareOff',
    placeOrder = 'placeOrder',
    holding = 'holding',
    depthScalper = 'DepthScalper',
    marketMovers = 'MarketMovers',
    marketAnalytics = 'MarketAnalytics',
    stopLoss = 'SL',
    batchOrder = 'BatchOrder',
    escalationMatrix = 'EscalationMatrix',
    repeat = 'Repeat',
    symbolAnalytics = 'SymbolAnalytics',
}

export enum ContractType {
    single = '',
    spread = 'S'
}

export enum ProductTypeSettingsCaps {
    Delivery = 'Delivery',
    Intraday = 'Intraday',
    CarryForward = 'CarryForward',
    MTF = 'MTF'
}

export enum ProductConversionMode {
    Net = 'Net',
    Buy = 'Buy',
    Sell = 'Sell'
}



export enum HoldingType {
    'normal' = 0,
    't+1' = 1,
    'None' = 2
}

export let OrderMode: OrderModeInterface;
(function (reverseInst) {
    reverseInst[reverseInst['buy'] = 'Buy'] = 'buy';
    reverseInst[reverseInst['sell'] = 'Sell'] = 'sell';
})(OrderMode || (OrderMode = <OrderModeInterface>{}));


export let OrderType: OrderTypeInterface;
(function (reverseOrder) {
    reverseOrder[reverseOrder['limit'] = 'Limit'] = 'limit';
    reverseOrder[reverseOrder['market'] = 'Market'] = 'market';
    reverseOrder[reverseOrder['stop_loss_market'] = 'Stop Loss Market'] = 'stop_loss_market';
    reverseOrder[reverseOrder['stop_loss_limit'] = 'Stop Loss Limit'] = 'stop_loss_limit';
    reverseOrder[reverseOrder['market_to_limit'] = 'MARKET_WITH_LEFT_OVER_AS_LIMIT'] = 'market_to_limit';
})(OrderType || (OrderType = <OrderTypeInterface>{}));

export let ReverseProductConversionMode: ProductConversionModeInterface;
(function (reverseInst) {
    reverseInst[reverseInst['net'] = 'Net'] = 'net';
    reverseInst[reverseInst['buy'] = 'Buy'] = 'buy';
    reverseInst[reverseInst['sell'] = 'Sell'] = 'sell';
})(ReverseProductConversionMode || (ReverseProductConversionMode = <ProductConversionModeInterface>{}));

// List of all order type that are of stop loss type. Including Order Type and reverse type so that it can be checked without conversion.
export const STOP_LOSS_ORDER_TYPE = [
    OrderType['Stop Loss Limit'], OrderType['Stop Loss Market'], OrderType.stop_loss_limit, OrderType.stop_loss_market
];

export let ReverseInstrumentMapping: ReverseInstrumentInterface;
(function (reverseInst) {
    reverseInst[reverseInst['common_stock'] = 'Equity'] = 'common_stock';
    reverseInst[reverseInst['future'] = 'Future'] = 'future';
    reverseInst[reverseInst['option'] = 'Option'] = 'option';
    reverseInst[reverseInst['index'] = 'Index'] = 'index';
})(ReverseInstrumentMapping || (ReverseInstrumentMapping = <ReverseInstrumentInterface>{}));


export let OrderStatusAcronym: OrderStatusInterface;
(function (reverseInst) {
    reverseInst[reverseInst['confirmed'] = 'Confirmed'] = 'confirmed';
    reverseInst[reverseInst['partially_filled'] = 'Partially Filled'] = 'partially_filled';
    reverseInst[reverseInst['replaced'] = 'Replaced'] = 'replaced';
    reverseInst[reverseInst['rejected'] = 'Rejected'] = 'rejected';
    reverseInst[reverseInst['new_rejected'] = 'New Rejected'] = 'new_rejected';
    reverseInst[reverseInst['rms_reject'] = 'RMS Rejected'] = 'rms_reject';
    reverseInst[reverseInst['RiskStatus_EXCHANGE_DISCONNECTED'] = 'EXCHANGE DISCONNECTED'] = 'RiskStatus_EXCHANGE_DISCONNECTED';
    reverseInst[reverseInst['replace_rejected'] = 'Replace Rejected'] = 'replace_rejected';
    reverseInst[reverseInst['cancel_rejected'] = 'Cancel Rejected'] = 'cancel_rejected';
    reverseInst[reverseInst['cancelled'] = 'Cancelled'] = 'cancelled';
    reverseInst[reverseInst['filled'] = 'Filled'] = 'filled';
    reverseInst[reverseInst['frozen'] = 'Frozen'] = 'frozen';
    reverseInst[reverseInst['pending_new'] = 'Pending New'] = 'pending_new';
    reverseInst[reverseInst['pending_replace'] = 'Pending Replace'] = 'pending_replace';
    reverseInst[reverseInst['pending_cancel'] = 'Pending Cancel'] = 'pending_cancel';
    reverseInst[reverseInst['amo_pending'] = 'AMO Pending'] = 'amo_pending';
    reverseInst[reverseInst['amo_replaced'] = 'AMO Replaced'] = 'amo_replaced';
    reverseInst[reverseInst['amo_cancelled'] = 'AMO Cancelled'] = 'amo_cancelled';
    reverseInst[reverseInst['amo_rejected'] = 'AMO Rejected'] = 'amo_rejected';
    reverseInst[reverseInst['amo_replace_rejected'] = 'AMO Replace Rejected'] = 'amo_replace_rejected';
    reverseInst[reverseInst['amo_cancel_rejected'] = 'AMO Cancel Rejected'] = 'amo_cancel_rejected';
    reverseInst[reverseInst['schedule_new'] = 'Scheduled'] = 'schedule_new';
    reverseInst[reverseInst['schedule_pending'] = 'Scheduled Pending'] = 'schedule_pending';
    reverseInst[reverseInst['schedule_replaced'] = 'Scheduled Replace'] = 'schedule_replaced';
    reverseInst[reverseInst['schedule_cancelled'] = 'Scheduled Cancelled'] = 'schedule_cancelled';
    reverseInst[reverseInst['schedule_rejected'] = 'Scheduled Rejected'] = 'schedule_rejected';
    reverseInst[reverseInst['open'] = 'Open'] = 'open';
    reverseInst[reverseInst['open'] = 'OPEN'] = 'OPEN';
    reverseInst[reverseInst['pending'] = 'PENDING'] = 'PENDING';
    reverseInst[reverseInst['triggered'] = 'TRIGGERED'] = 'TRIGGERED';
    reverseInst[reverseInst['expired'] = 'EXPIRED'] = 'EXPIRED';
    reverseInst[reverseInst['rejected'] = 'REJECTED'] = 'REJECTED';
    reverseInst[reverseInst['cancelled'] = 'CANCELLED'] = 'CANCELLED';
})(OrderStatusAcronym || (OrderStatusAcronym = <OrderStatusInterface>{}));

/**
 * =====================================================
 * ==================== KYC Enums ======================
 * =====================================================
 */

export enum KycStatus {
    approved = 'approved',
    rejected = 'rejected',
    pending = 'pending'
}

export enum KycStatusColor {
    approved = 'kyc-status-approved',
    rejected = 'kyc-status-rejected',
    pending = 'kyc-status-pending'
}

export enum KycDisplayStatus {
    approved = 'Approved',
    rejected = 'Rejected',
    pending = 'Pending',
    not_done = 'Not Done'
}

export enum SignupFlags {
    DEFAULT = 'DEFAULT',
    CUSTOM = 'CUSTOM',
    DISABLED = 'DISABLED'
}

export enum MarketWatchNames {
    DEFAULT = 'default'
}

/**
 * =====================================================
 * ============== Market Segment Enum ==================
 * =====================================================
 */

export enum MarketSegment {
    CDS = 'CDS',
    CD = 'CD',
    CM = 'CM'
}

/**
 * =====================================================
 * ============== Advance Orders Enum ==================
 * =====================================================
 */

export enum AdvanceOrder {
    REGULAR = 'REGULAR',
    CO = 'CO',
    BO = 'BO',
    GTT = 'GTT',
    AMO = 'AMO',
    SUPER = 'SUPER',
    SMART = 'SMART'
}

export enum AdvanceOrders {
    REGULAR = 'REGULAR',
    BOCO = 'BOCO',
    GTT = 'GTT',
    SMART = 'SMART',
    SUPER = 'SUPER'
}

export enum Reports {
    financial_ledger = 'Financial Ledger',
    fund_summary = 'Fund Summary',
    trade_summary = 'Trade Summary',
    dp_transaction = 'DP Transaction',
    net_positions = 'Net Position',
    backOffice_holdings = 'Holdings',
    daily_mtmBill = 'Daily MTM Bill',
    client_fifo = 'FnO P&L',
    contract_document = 'Contract Document',
}
export enum ContractResponseType {
    success = 'Success',
    system_error = 'SystemError'
}
export enum ContractCompanName {
    SHAREINDIA = 'ShareIndia',
}
export enum ContractJobName {
    EQUITY_CONTRACT_NOTE = 'EquityContractNotes'
}
export const BOCOProductTypes = [
    AdvanceOrder.CO, AdvanceOrder.BO
];

export enum bocoType {
    BO = 'BO',
    CO = 'CO'
}

export let ReverseAdvanceOrderType: AdvanceOrderTypesI;
(function (reverseAdvanceOrderType) {
    reverseAdvanceOrderType[reverseAdvanceOrderType['Bracket Order'] = AdvanceOrder.BO] = 'Bracket Order';
    reverseAdvanceOrderType[reverseAdvanceOrderType['Cover Order'] = AdvanceOrder.CO] = 'Cover Order';
    reverseAdvanceOrderType[reverseAdvanceOrderType['Regular'] = AdvanceOrder.REGULAR] = 'Regular';
    reverseAdvanceOrderType[reverseAdvanceOrderType['AMO'] = AdvanceOrder.AMO] = 'AMO';
    reverseAdvanceOrderType[reverseAdvanceOrderType['GTT'] = AdvanceOrder.GTT] = 'GTT';
    reverseAdvanceOrderType[reverseAdvanceOrderType['Smart'] = AdvanceOrder.SMART] = 'Smart';
    reverseAdvanceOrderType[reverseAdvanceOrderType['Super'] = AdvanceOrder.SUPER] = 'Super';
    reverseAdvanceOrderType[reverseAdvanceOrderType['BOCO'] = AdvanceOrders.BOCO] = 'BOCO';
})(ReverseAdvanceOrderType || (ReverseAdvanceOrderType = <AdvanceOrderTypesI>{}));

export enum BOCOPriceType {
    ABSOLUTE = 'absolute',
    TICKS = 'tick'
}

export enum BOCODisplayOrderType {
    absolute = 'abs',
    tick = 'ticks'
}

export enum BOCOStopModeTypes {
    FIXED = 'fixed',
    TRAILING = 'trailing'
}

export enum SymbolLoadingStatus {
    pending = 'PENDING',
    success = 'SUCCESS',
    failed = 'FAILED'
}

export enum ChartType {
    DEFAULT = 'Default Chart',
    CHARTIQ = 'Chart IQ',
    TRADING_VIEW = 'Trading View'
}

export enum SocketErrorCodes {
    InvalidSocket = 1029,
    SocketAuthentication = 1030,
    AppVersionNotSupported = 1040,
    AccountNotActive = 1007,
    UserDoesNotExist = 1044,
    ExchangeNotMapped = 1045,
    userLocked = 1008,
    userPasswordNotSet = 1047,
    userAccountExpired = 1048
}

export enum BracketCoverOrderState {
    OrderState_Parent = 0,
    OrderState_Stop_Loss = 1,
    OrderState_Target = 2,
    OrderState_Exit = 3,
    OrderState_Square_Off = 4
}

export enum AddRemoveSymbolCommand {
    add = 'add',
    remove = 'delete'
}

export enum SubscriptionTables {
    marketWatch = 'marketWatch',
    positions = 'positions',
    indices = 'indices',
    depth = 'depth',
    spreadForm = 'spreadForm',
    depthScalper = 'depthScalper',
    holding = 'holding',
    chart = 'chart',
    orderWidget = 'OrderWidget',
    orderForm = 'orderForm',
    marketmovers = 'marketMovers',
    mostActive = 'mostActive',
    batchOrder = 'batchOrder',
    smartMW = 'smartMW',
}

// Using this as a const as number keys are not allowed in Enum. But it's purpose is like a Enum only.
export const MarketType = {
    0: 'Normal',
    1: 'Odd Lot',
    2: 'Spot',
    3: 'Auction',
    4: 'Call Auction 1',
    5: 'Call Auction 2',
    6: 'Normal Call Auction',
    7: 'SPOS',
    8: 'PCAS1',
    9: 'PCAS2',
    10: 'Max'
};

export const CurrentSession = {
    0: 'Pre Open',
    1: 'Open',
    2: 'Closed',
    3: 'Preopen Closed',
    4: 'Post Closed',
    5: 'Halted',
    6: 'Post Open',
    7: 'Start Day Login',
    8: 'End Of Day',
    9: 'Member Query Session',
    10: 'Matching Session End',
    11: 'Preopen Matching Session End',
    12: 'Max'
};

export enum DeepLinkRoutes {
    VERIFY_EMAIL_ROUTE = 'confirm-email'
}

export enum BanType {
    FO = 'FO',
    ASM_GSM = 'ASM/GSM',
    NONE = ''
}

export enum STORAGE_TYPES {
    CURRENT = `CIQ.Themes.prototype.current`,
    CUSTOM = 'CIQ.Themes.prototype.custom',
    VIEWS = 'stx-views'
}

export enum STORAGE_KEYS {
    THEME = 'CHARTING_THEME',
    VIEWS = 'CHARTING_VIEWS'
}

export enum MarketKeywords {
    BSECM = 'BSECM',
    BSEFO = 'BSEFO',
    NSECM = 'NSECM',
    NSEFO = 'NSEFO',
    ESMNSE = 'ESMNSE',
    ESM = 'ESMNSE',
    NSECDS = 'NSECDS',
    BSECDS = 'BSECDS',
    MSECM = 'MSECM',
    MSECD = 'MSECD',
    MSEFO = 'MSEFO',
    PLUS = 'PLUS',
    MCX = 'MCX',
    NCDEX = 'NCDEX',
    ESM_SHORT = 'ESM'
}

export enum MarketIndex {
    nsecm = MarketKeywords.NSECM,
    bsecm = MarketKeywords.BSECM,
    esmnse = MarketKeywords.ESMNSE,
}

export enum PaymentModes {
    UPI = 'upi',
    NetBanking = 'net_banking',
}

export enum TransactionModes {
    Payin = 'deposit',
    Payout = 'withdraw',
    All = 'all',
    Deduction = 'deduction'
}

export enum TransactionStatus {
    Failed = 'FAILED',
    Success = 'SUCCESS',
    Pending = 'PENDING',
    Initiated = 'INITIATED',
    Cancelled = 'CANCELLED'
}

export enum ChartIQFrameMessageTypes {
    init = 0,
    symbolSubscribe = 1,
    symbolUnsubscribe = 2,
    socketUpdate = 3,
    symbolSearch = 4,
    placeOrder = 5,
    validProducts = 6,
    fetchOHLC = 7,
    ohlcDataReceived = 8
}

export enum ChartIQInstrumentType {
    'STOCKS' = 'common_stock',
    'FUTURES' = 'future',
    'OPTIONS' = 'option'
}

export enum PaymentGateways {
    disabled = '',
    custom = 'custom',
    cashfree = 'cashfree',
    razorpay = 'razorpay',
    hdfc = 'hdfc',
}

export enum WidgetNames {
    Orders = 'Orders',
    Positions = 'Positions',
    PortFolio = 'Portfolio'
}

export enum ThemeNames {
    MINIMAL_WHITE = 'MINIMAL_WHITE',
    MIDNIGHT_BLUE = 'MIDNIGHT_BLUE',
    ELEGANT_BLACK = 'ELEGANT_BLACK'
}

export enum ChartBGColor {
    MINIMAL_WHITE = '#ffffff',
    MIDNIGHT_BLUE = '#031424',
    ELEGANT_BLACK = '#0E1111'
}

export enum CustomDateTimeFormat {
    standard_date_time = 'dd MMMM y hh:mm:ss',
    standard_date_24_hr_time = 'dd MMMM y HH:mm:ss',
    mediumTimePadded = 'hh:mm:ss a',
    reversed_date_time = 'y-M-dd HH:mm:ss',
    date_only = 'MM/dd/yy',
    time_only = 'HH:mm:ss',
    time_only_short = 'h:mm a',
    ipo_date_format = 'dd-MM-yy',
    ipo_info_date_format = 'dd MMM \'\'yy',
    moment_date_format = 'DD-MM-YYYY',
    shortDateMediumTime = 'M/d/yy hh:mm:ss a',
    time_only_short_capitalized = 'h:mm A',
    time_with_seconds_capitalized = 'hh:mm:ss A',
    funds_date_format = 'DD MMM YY',
    sip_data_format = 'dd MMM yy',
    books_info_time_format = 'yyyy-MM-dd HH:mm:ss',
    month_year_label = 'MMM YYYY',
    iso_date_format = 'yyyy-MM-dd',
    gtt_date_format = 'dd MMM, yyyy',
    gtt_books_date_format = 'dd MMM, yy',
    time_24_hr_without_seconds = 'HH:mm'
}

export enum WidgetTitles {
    marketWatch = 'Marketwatch'
}

export enum SecondsIn {
    MINUTE = 60,
    HOUR = 3600,
    DAY = 86400
}

export enum OrderStatusKind {
    confirmed = 'confirmed',
    rejected = 'rejected',
    filled = 'filled'
}

export enum MostActiveSortTypes {
    volume = 'volume',
    value = 'value'
}
export enum MarketMoversKeys {
    gainers = 'gainers',
    losers = 'losers'
}

export enum PreferredMarketIndices {
    bsecm = 'Sensex',
    nsecm = 'Nifty 50'
}
/**
 * key:- order status
 * value:- mat icon name
 */
export enum StatusToIconMap {
    confirmed = 'done',
    filled = 'done_all',
    rejected = 'clear'
}

export enum PledgeResponseStatus {
    success = '0',
    failure = '1',
    overdue = '2'
}

export enum PledgeStatus {
    success,
    partial_success,
    failure
}


export enum OrderStatusKindMap {
    confirmed = 'confirmed',
    partially_filled = 'filled',
    replaced = 'confirmed',
    rms_reject = 'rejected',
    new_rejected = 'rejected',
    replace_rejected = 'rejected',
    cancel_rejected = 'rejected',
    cancelled = 'rejected',
    filled = 'filled',
    frozen = 'confirmed',
    pending_new = 'confirmed',
    pending_replace = 'confirmed',
    pending_cancel = 'rejected',
    amo_pending = 'confirmed',
    amo_replaced = 'confirmed',
    amo_cancelled = 'rejected',
    amo_rejected = 'rejected',
    amo_replace_rejected = 'rejected',
    amo_cancel_rejected = 'rejected'
}

export enum EDISStatus {
    SUCCESS = 'success',
    FAILURE = 'failure'
}

export enum PledgeStatusResponse {
    OTP_VERIFIED = 'OTP_VERIFIED',
    PENDING = 'PENDING',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS'
}

export enum ObjectKeyValue {
    KEY,
    VALUE,
    DATA,
    KEYOBJECT
}

export enum Segments {
    NSE = 'NSE',
    BSE = 'BSE',
    NSEFO = 'NSEFO'
}

export const FifoTable = {
    'Contract Details': 1,
    'Expense Details': 2
}

/**
 * 
 * @param marketId Specify Market which can be NCECM or BSECM
 * @param code Specify asm_gsm_surveillance_indicator code which need special handling for 82, 83 and 84 code according to market
 */
export const getBanError = (marketId: MarketKeywords, code: number) => {
    switch (code) {
        case 82:
            if (marketId == MarketKeywords.NSECM) {
                return 'Scrip is in BZ/SZ series';
            }
            return 'Scrip is in Z group';
        case 83:
            if (marketId == MarketKeywords.NSECM) {
                return 'Company has failed to pay Annual listing fee';
            }
            return 'Company not paid listing fees';
        case 84:
            if (marketId == MarketKeywords.NSECM) {
                return 'Derivative contracts in the scrip to be moved out of F&O';
            }
            return 'Security scheduled to be made out of Derivatives';
        default:
            return errorCodeMapping[code];
    }
}

export const errorCodeMapping: { [key: string]: string } = {
    1: 'GSM Stage 1',
    2: 'GSM Stage 2',
    3: 'GSM Stage 3',
    4: 'GSM Stage 4',
    5: 'GSM Stage 5',
    6: 'GSM Stage 6',
    11: 'ASM ST-Stage 1',
    12: 'ASM ST-Stage 2',
    13: 'ASM LT-Stage 1',
    14: 'ASM LT-Stage 2',
    15: 'ASM LT-Stage 3',
    16: 'ASM LT-Stage 4',
    20: 'ASM-IBC Receipt(20)',
    21: 'ASM-IBC 1',
    22: 'ASM-IBC 2',
    23: 'ASM-ICA Stage 1',
    24: 'ASM-ICA Stage 2',
    25: 'High Promoter Encumbrance',
    26: 'High Promoter/Non Promoter Encumbrance',
    30: 'Unsolicited SMS',
    31: 'Unsolicited SMS',
    32: 'Unsolicited Video',
    34: 'ESM Stage 1',
    35: 'ESM Stage 2',
    36: 'ESM1 & GSM0 Stage 1',
    37: 'ESM2 & GSM0 Stage 2',
    50: 'LTASM1 & GSM0 Stage 1',
    51: 'LTASM2 & GSM0 Stage 2',
    52: 'LTASM3 & GSM0 Stage 3',
    53: 'LTASM4 & GSM0 Stage 4',
    54: 'STASM1 & GSM0 Stage 1',
    55: 'STASM2 & GSM0 Stage 2',
    56: 'High Promoter/Non Promoter Encumbrance & GSM0',
    57: 'High Promoter Encumbrance & GSM0',
    58: 'IBC1 & GSM0 Stage 1',
    59: 'IBC2 & GSM0 Stage 2',
    60: 'ICA1 & GSM0 Stage 1',
    61: 'ICA2 & GSM0 Stage 2',
    62: 'IBC0 & GSM0',
    63: 'IBC0 & GSM1',
    64: 'IBC0 & GSM2',
    65: 'IBC0 & GSM3',
    66: 'IBC0 & GSM4',
    80: 'Loss Making for Last 8 Quarters',
    81: 'Encumbrance of Promoters/promoter group shareholding more than 50%',
    85: 'Default',
    86: 'Add-on PB',
    87: 'Social Media Platforms',
    99: 'GSM Shortlisted',
};

export enum EDISAction {
    Authorize = 'Pending',
    Unauthorize = 'Unauthorize'
}

export enum TOTPStatus {
    Disabled,
    Verify,
    QR,
    Enabled,
}

export enum userAuthenticationStatus {
    unauthorised = 'Unauthorized'
}

export enum StrategyIdType {
    StrategyIdDefault = 0,
    StrategyIdUnhedge = 1,
    StrategyIdRms = 2,
    StrategyIdBoco = 3,
    StrategyIdMax = 4
}

export enum ReportsColumns {
    document_name = 'document_name',
    document_url = 'document_url',
    date = 'date'
}

export enum SislWealthClientStatus {
    success = 'success',
    failure = 'failure',
    pending = 'pending'
}

export enum SortStateKeys {
    holding = "holdingSortData",
    order = "orderSortData",
    position = "positionSortData",
    trade = "tradeSortData",
    mutualFunds = "mutualFundsSortData",
    stockSip = "stockSipSortData",
    gttbook = "gttbookSortData",
    superbook = "superbookSortData",
    mtfHolding = "mtfHoldingSortData",
    smartbook = "smartbookSortData"
}

export enum ProductTypeAbbr {
    CarryForward = 'CF',
    Intraday = 'ITR',
    Delivery = 'DEL',
    MTF = 'MTF'
}

export enum HoldingFilterKeys {
    SECURITY_TYPE = 'securityTypeFilter',
    IS_FILTERING = 'isFiltering'
}